import React from 'react';
import cn from 'classnames';
import BeachLineFeature from './components/BeachLineFeature/BeachLineFeature';
import BeachSurfaceFeature from './components/BeachSurfaceFeature';
import BeachDistanceFeature from './components/BeachDistanceFeature/BeachDistanceFeature';
import AirportDistanceFeature from './components/AirportDistanceFeature';
import WifiTypeFeature from './components/WifiTypeFeature';
import type { HotelFeatures } from '../../types';

import styles from './hotelCardFeatures.module.css';
import SkiLiftDistanceFeature from './components/SkiLiftDistanceFeature/SkiLiftDistanceFeature';
import CityCenterDistanceFeature from './components/CityCenterDistanceFeature/CityCenterDistanceFeature';

type HotelCardFeaturesProps = {
  isMobile: boolean;
  features: HotelFeatures;
  isMapCard?: boolean;
  skiLiftDistance: number;
};

const HotelCardFeatures = ({
  features,
  isMobile,
  isMapCard,
  skiLiftDistance,
}: HotelCardFeaturesProps) => (
  <div
    className={cn(styles.container, {
      [styles.mobileContainer]: isMobile,
      [styles.scroll]: isMapCard && !isMobile,
    })}
  >
    <SkiLiftDistanceFeature value={skiLiftDistance} isMobile={isMobile} />
    <BeachLineFeature value={features.beachLine} isMobile={isMobile} />
    <BeachSurfaceFeature value={features.beachSurface} isMobile={isMobile} />
    <BeachDistanceFeature value={features.beachDistance} isMobile={isMobile} />
    <CityCenterDistanceFeature
      value={features.distanceToCityCenter}
      isMobile={isMobile}
    />
    <AirportDistanceFeature
      value={features.airportDistance}
      isMobile={isMobile}
    />
    <WifiTypeFeature value={features.wiFi} isMobile={isMobile} />
  </div>
);

export default HotelCardFeatures;
